import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
]

const router = new VueRouter({
  routes
})

export default router



//////////////////
// WEBPACK FOOTER
// ./router/index.js
// module id = null
// module chunks = 